import styled from 'styled-components';

export const Desc = styled.div`
	padding-bottom: 60px;
	max-width: 680px;
`;

export const DevHeadContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 24px 24px 0 24px;
`;

export const DevLogo = styled.div`
	height: 62px;
	width: 180px;
	margin-top: 16px;
`;

export const DevLogoImage = styled.img`
	object-fit: contain;
	max-width: 70%;
	max-height: 100%;
`;

export const RatingContainer = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const Separator = styled.div`
	height: 1px;
	width: 100%;
	margin: 16px 0;
	background: ${({ theme }) => theme.lightGrayColor};
`;

export const DescItemContainer = styled.div`
	margin: 0 auto 0 0;
	${({ theme }) => theme.typography.textMediumS};
	color: ${({ theme }) => theme.primaryBlackColor};
`;

export const DescItemTitle = styled.div`
	margin: 4px 0;
	color: ${({ theme }) => theme.darkGrayColor};
	${({ theme }) => theme.typography.textXS};
`;

export const DescItemValue = styled.div`
	${({ theme }) => theme.typography.textSemiBoldS};
`;

export const DevDesc = styled(Desc)`
	display: flex;
	max-height: 100%;
	margin-bottom: 32px;
`;

export const PropertiesButtonContainer = styled.div`
	width: 100%;
	height: auto;
`;

export const PropertiesButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 52px;
	text-align: center;
	cursor: pointer;
	border: none;
	padding: 0;
	margin: 0;
	${({ theme }) => theme.typography.buttonS}
	background: ${({ theme }) => theme.secondaryColor};
	color: ${({ theme }) => theme.primaryColor};
`;

export const DeveloperContainer = styled.div`
	display: flex;
	border: 2px solid ${({ theme }) => theme.lightGrayColor};
	border-radius: 4px;
	${({ theme }) => theme.typography.textM};

	&:hover {
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

		${PropertiesButton} {
			background: ${({ theme }) => theme.secondaryHover};
		}
	}

	& > a,
	& > button {
		text-decoration: none;
	}
	@media (max-width: 768px) {
		max-width: unset;
	}
`;
